import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from './service-requirement.actions';
import * as fromGraphql from './service-requirement.graphql';


@Injectable()
export class ServiceRequirementEffects {
  createServiceRequirementMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceRequirementMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_REQUIREMENT,
        variables: {
          input: action?.input
        }
      })
      .pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {
          console.log(data)
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertServiceRequirement({ serviceRequirement: result?.data })
              );
              this.notificationService.successMessage('Created Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateServiceRequirementMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateServiceRequirementMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_SERVICE_REQUIREMENT,
        variables: {
          input: action?.input
        }
      })
      .pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertServiceRequirement({ serviceRequirement: result?.data })
              );
              this.notificationService.successMessage('Updated Successfully');
            }
            else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteServiceRequirementGroupMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deleteServiceRequirementMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_SERVICE_REQUIREMENT,
        variables: {
          requirementUniqueId: action?.requirementUniqueId
        }
      })
      .pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceRequirement({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceRequirements = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceRequirements),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SERVICE_REQUIREMENTS,
        fetchPolicy: 'network-only',
        variables: {
          groupUniqueId: action.groupUniqueId
        }
      })
      .pipe(
        this.notificationService.catchError('Problem occurred while fetching service requirements'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceRequirements({ serviceRequirements: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
  ) {}
}
